import * as React from 'react';
import { view } from 'react-easy-state';

export default view(() => {
  return (
    <section id='organizations' className='section has-text-dark'>
        <div className='container has-text-left pb-5'>
          <h1 className='super subtitle'>Some organizations I've worked with in the last 10+ years, mainly accross Europe &amp; Latin America:</h1>
        </div>
        <div className=''>
          <div className='container lead has-text-centered'>
            <div className='columns is-centered is-mobile is-multiline'>
              <div className='column py-4 is-one-third'>
                <h2 className=''>ASML</h2>
              </div>
              <div className='column py-4 is-one-third'>
                <h2 className=''>Eindhoven University of Technology</h2>
              </div>
              <div className='column py-4 is-one-third'>
                <h2 className=''>Atos Spain</h2>
              </div>
              <div className='column py-4 is-one-third'>
                <h2 className=''>The Robert Gordon University</h2>
              </div>
              <div className='column py-4 is-one-third'>
                <h2 className=''>Universiteit Hasselt</h2>
              </div>
              <div className='column py-4 is-one-third'>
                <h2 className=''>Fundación Virtualware Labs</h2>
              </div>
              <div className='column py-4 is-one-third'>
                <h2 className=''>Peerby</h2>
              </div>
              <div className='column py-4 is-one-third'>
                <h2 className=''>Intrasoft</h2>
              </div>
              <div className='column py-4 is-one-third'>
                <h2 className=''>Norwich University of Arts</h2>
              </div>
              <div className='column py-4 is-one-third'>
                <h2 className=''>DesignLab.gr</h2>
              </div>
              <div className='column py-4 is-one-third'>
                <h2 className=''>Telcel</h2>
              </div>
              <div className='column py-4 is-one-third'>
                <h2 className=''>Claro Americas</h2>
              </div>
            </div>
          </div>
        </div>
    </section>
  )
});
